export default __webpack_public_path__ + "static/background-gradient-dark-purple-outline-eeeea99c6db10c3db9e37060ff42f51c.webp";